export { DeflistNode } from './DeflistSpecs';
export const dlAction = 'toDefList';
